import { render, staticRenderFns } from "./CreateNewRootFolder.vue?vue&type=template&id=e14136a6&"
import script from "../../scripts/overlay/CreateNewRootFolder.js?vue&type=script&lang=js&"
export * from "../../scripts/overlay/CreateNewRootFolder.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports